import { FC } from 'react';
import { CardRanking } from '@features/ui';
import { PaAccounts } from '@src/types';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '@lib/utils.ts';

interface PayoutRankingProps {
  item: PaAccounts | null;
}
export const PayoutRanking: FC<PayoutRankingProps> = ({ item }) => {
  const { t } = useTranslation();

  const payoutLogic = item?.payout_logics.find(
    (payoutLogicItem) =>
      payoutLogicItem.payout_number === item.payout_status.payout_number
  );

  const isTradingDays =
    Number(item?.payout_status.trading_days_since_last_payout) >
    Number(payoutLogic?.payout_request_after_days);

  const isProfit =
    Number(item?.payout_status.profit_current) >
    Number(payoutLogic?.min_payout);

  const isRule =
    Number(item?.payout_status.thirty_percent_profit_rule_rate) >
    Number(item?.payout_status.thirty_percent_profit_rule);

  return (
    <div className={'mt-8 mb-9 text-xs'}>
      <div className={'w-[379px]'}>
        <div className={'flex justify-between text-sm mb-1'}>
          <p>Requirements for your 1st Payout</p>
          <p className={'w-[20%] mr-2.5'}>Actual</p>
        </div>
        <CardRanking
          bgColor={isTradingDays ? '#14CA74' : '#C72E2E'}
          opacity={isTradingDays ? 0.9 : 0.6}
        >
          <div className={'flex justify-between items-center h-[26px] px-2.5'}>
            <p>
              {payoutLogic?.payout_request_after_days}+ Trading Days
              {payoutLogic?.daily_profit_required
                ? `, with daily profit of ${payoutLogic?.daily_profit_required_amount ?? 0}`
                : ''}
            </p>
            <p className={'w-[20%]'}>
              {t('payoutRequest.days', {
                day: item?.payout_status.trading_days_since_last_payout,
              })}
            </p>
          </div>
        </CardRanking>
        <CardRanking
          bgColor={isProfit ? '#14CA74' : '#C72E2E'}
          opacity={isProfit ? 0.7 : 0.9}
        >
          <div className={'flex justify-between items-center h-[26px] px-2.5'}>
            <p>Profit #{payoutLogic?.min_payout ?? 0}+</p>
            <p className={'w-[20%]'}>
              $
              {formatCurrency(
                Number(item?.payout_status.profit_current ?? 0),
                2
              )}
            </p>
          </div>
        </CardRanking>
        <CardRanking
          bgColor={isRule ? '#14CA74' : '#C72E2E'}
          opacity={isRule ? 0.6 : 0.7}
        >
          <div className={'flex justify-between items-center h-[26px] px-2.5'}>
            <p>{item?.payout_status.thirty_percent_profit_rule_rate}%</p>
            <p className={'w-[20%]'}>
              {item?.payout_status.thirty_percent_profit_rule}%
            </p>
          </div>
        </CardRanking>
      </div>
      <div className={'flex flex-col gap-2 mt-3.5'}>
        <p>
          Customer Message: You have an active payout in progress for $2000
          awaiting staff approval
        </p>
        <p className={'font-bold'}>
          Note: All rules will be reviewed by the Leeloo team including
          flipping, consistency, contract usage.
        </p>
      </div>
    </div>
  );
};
